var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_50333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.002 20.1328C15.5248 20.1328 20.002 15.6557 20.002 10.1328C20.002 4.60997 15.5248 0.132812 10.002 0.132812C4.47911 0.132812 0.00195312 4.60997 0.00195312 10.1328C0.00195312 15.6557 4.47911 20.1328 10.002 20.1328Z",
    fill: "url(#paint0_linear_1481_50333)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52782 10.0268C7.44302 8.75668 9.38695 7.91934 10.3596 7.51479C13.1367 6.35969 13.7138 6.15904 14.0899 6.15241C14.1726 6.15096 14.3576 6.17146 14.4774 6.26868C14.5785 6.35077 14.6064 6.46166 14.6197 6.53949C14.633 6.61732 14.6496 6.79462 14.6364 6.93316C14.4859 8.51439 13.8348 12.3516 13.5035 14.1226C13.3633 14.872 13.0873 15.1233 12.8201 15.1479C12.2393 15.2013 11.7984 14.7641 11.2359 14.3954C10.3558 13.8185 9.85857 13.4593 9.00425 12.8963C8.01694 12.2457 8.65697 11.8881 9.21964 11.3037C9.36689 11.1508 11.9256 8.82347 11.9751 8.61235C11.9813 8.58595 11.987 8.48752 11.9285 8.43555C11.8701 8.38358 11.7838 8.40135 11.7215 8.41549C11.6332 8.43552 10.2272 9.36485 7.50344 11.2035C7.10435 11.4775 6.74286 11.611 6.41898 11.604C6.06193 11.5963 5.37511 11.4022 4.86452 11.2362C4.23827 11.0326 3.74054 10.925 3.78388 10.5793C3.80646 10.3992 4.05443 10.215 4.52782 10.0268Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1481_50333",
    x1: 1000,
    y1: 0.132812,
    x2: 1000,
    y2: 1985.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_50333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00195312 0.132812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e1453fad08533643bdc3fe626861b095.svg";
export { ForwardRef as ReactComponent };